import React, { useCallback } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'app/components/ui/select';
import { PRODUCT_STATUS, PRODUCT_TYPE } from 'utils/constants';
import { useFormContext } from 'react-hook-form';

function ProductStatus() {
  const form = useFormContext();

  // Memoize handler to prevent unnecessary re-renders
  const handleStatusChange = useCallback(
    (value: string) => {
      form.setValue('status', value);
    },
    [form],
  );

  return (
    <div className="bg-white/90 dark:bg-gray-800/90 backdrop-blur-sm rounded-lg border border-gray-200/50 dark:border-gray-700/50">
      <div className="px-4 py-3 border-b border-gray-100 dark:border-gray-700 bg-gradient-to-r from-purple-50 to-pink-50 dark:from-gray-800 dark:to-gray-700 rounded-t-lg">
        <div className="flex items-center space-x-2">
          <div className="w-6 h-6 bg-gradient-to-r from-purple-500 to-pink-500 rounded-md flex items-center justify-center">
            <svg
              className="w-3 h-3 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <div>
            <h3 className="font-semibold text-sm text-gray-900 dark:text-gray-100">
              Product Status
            </h3>
            <p className="text-xs text-gray-600 dark:text-gray-400">
              Control product visibility
            </p>
          </div>
        </div>
      </div>

      <div className="p-4">
        <Select
          value={form.watch('status')?.toString() || ''}
          onValueChange={handleStatusChange}
        >
          <SelectTrigger className="h-10 w-full bg-white dark:bg-gray-700 border-gray-200 dark:border-gray-600 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 rounded-lg transition-all duration-200">
            <SelectValue placeholder="Select status" />
          </SelectTrigger>
          <SelectContent className="rounded-lg border border-gray-200 dark:border-gray-600">
            {Object.keys(PRODUCT_STATUS).map(key => (
              <SelectItem key={key} value={key} className="rounded-md">
                <div className="flex items-center space-x-2">
                  <div
                    className={`w-2 h-2 rounded-full ${
                      key === '1' // Draft
                        ? 'bg-yellow-500'
                        : key === '2' // Active
                        ? 'bg-green-500'
                        : key === '3' // Inactive
                        ? 'bg-red-500'
                        : key === '4' // Archived
                        ? 'bg-gray-500'
                        : 'bg-gray-400'
                    }`}
                  />
                  <span className="text-sm">{PRODUCT_STATUS[key]}</span>
                </div>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}

export default ProductStatus;
